/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NewMessage } from '../models/NewMessage';
import type { SupportProfile } from '../models/SupportProfile';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SupportService {
    /**
     * Support Profile
     * @returns SupportProfile Successful Response
     * @throws ApiError
     */
    public static supportProfileApiSupportProfileGet(): CancelablePromise<SupportProfile> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/support/profile',
        });
    }
    /**
     * Send Message To Support
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    public static sendMessageToSupportApiSupportNewMessagePost(
        requestBody: NewMessage,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/support/new-message',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
